
export const massesH5Router = [
  {
    path: '',
    redirect: 'index'
  },
  {
    path: 'index',
    meta: {
      title: '海淀区科技类校外培训行业规范发展服务平台',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/index'),
  },
  {
    path: 'publicizeList',
    meta: {
      title: '宣传信息',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/publicizeList'),
  },
  {
    path: 'policyList',
    meta: {
      title: '政策法规',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/policyList'),
  },
  {
    path: 'technologyList',
    meta: {
      title: '科技专栏',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/technologyList'),
  },
  {
    path: 'orgList',
    meta: {
      title: '',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/orgList'),
  },
  {
    path: 'detail',
    meta: {
      title: '',
      needLogin: false // 是否需要登录才能访问
    },
    component: () => import('../views/h5/pages/detail'),
  }
]




export default massesH5Router
